export default __webpack_public_path__ + "static/media/slide7.ab61a315.jpg";